export interface SignedInDoctor {
  id: number;
  username: string;
  createdAt?: Date;
  updatedAt?: Date;
  name?: string;
  surname?: string;
  email?: string;
  emailConfirmed?: boolean;
  telephone?: string;
  telephoneD?: string;
  website?: string;
  websiteD?: string;
  studioMaster: boolean;
  medicalStudioId: number;
  token: string;
  patients?: number;
}

export const UnloggedDoctor: SignedInDoctor = {
  id: -1,
  username: "",
  studioMaster: false,
  medicalStudioId: NaN,
  token: "",
};

export const UnloggedAdmin: SignedInDoctor = {
  id: -111,
  username: "",
  studioMaster: false,
  medicalStudioId: NaN,
  token: "",
};
